import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  FUNDING_AREA_LIST,
  reloadFundingAreaList,
  SELECTED_FUNDING_AREA,
  SELECTED_PROGRAM,
  SELECTED_PROGRAM_INSTANCE,
  SELECTED_PROJECT,
  setPropertyValue
} from "../../../ducks/fundingArea";
import FundingArea from "./FundingArea";

//map properties from duck into component
const mapStateToProps = (state) => {
  return {
    fundingAreaList: state.fundingArea[FUNDING_AREA_LIST],
    selectedFundingArea: state.fundingArea[SELECTED_FUNDING_AREA],
    selectedProgram: state.fundingArea[SELECTED_PROGRAM],
    selectedProject: state.fundingArea[SELECTED_PROJECT],
    selectedProgramInstance: state.fundingArea[SELECTED_PROGRAM_INSTANCE]
  };
};

//map funcions that will go to dispatch in duck
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ reloadFundingAreaList, setPropertyValue }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FundingArea);
